import { InterestRatesHistoricalSliderItem } from '../types';

export const sliderItems: InterestRatesHistoricalSliderItem[] = [
  {
    year: 'Heden',
    content: [
      {
        title: 'Heden',
        position: 8,
        description:
          'Na de forse rentestijging in 2022 zijn de marktrentes inmiddels weer gestabiliseerd. Daarmee bleef ook de hypotheekrente ongeveer op hetzelfde niveau. Na een periode met relatief weinig renteschommelingen was er zelfs sprake van een lichte daling van de hypotheekrente.'
      }
    ]
  },
  {
    year: '2022',
    content: [
      {
        title: '2022',
        position: 8,
        description:
          'Begin 2022 veerden de marktrentes op vanaf hun zeer lage niveaus. De belangrijkste oorzaak waren hogere inflatieverwachtingen in het eurogebied, zeker sinds de oorlog in Oekraïne. Ook stopte de ECB met het opkopen van obligaties en werden renteverhogingen aangekondigd tegen de hoge inflatie.'
      }
    ]
  },
  {
    year: '2019',
    content: [
      {
        title: '2019',
        position: 7,
        description:
          'Verschillende stimuleringsmiddelen zorgden ervoor dat de kapitaalmarktrentes daalden en daardoor dus ook de hypotheekrentes. De hypotheekrentes voor een rentevaste periode van 10 jaar stond in 2019 voor het eerst onder de 1% (annuïteitenhypotheek met NHG).'
      }
    ]
  },
  {
    year: '2012',
    content: [
      {
        title: '2012',
        position: 6,
        description:
          'De hypotheekrentes zijn voornamelijk gedaald, met name als gevolg van het door de Europese Centrale Bank (ECB) zelf in stappen verlagen van de ECB-rente.'
      }
    ]
  },
  {
    year: '2006',
    content: [
      {
        title: '2006',
        position: 5,
        description: 'Na 2005 stegen de tarieven weer tot aan de financiële crisis in 2008 en 2009.'
      }
    ]
  },
  {
    year: '2001',
    content: [
      {
        title: '2001',
        position: 4,
        description:
          'Als gevolg van onzekerheid op de beurzen en het uiteenspatten van de internetbubbel stegen de rentestanden opnieuw. Van 2001 tot en met 2005 ging de hypotheekrente weer verder naar beneden, uitkomend op een gemiddelde hypotheekrente van zo’n 4%.'
      }
    ]
  },
  {
    year: '1990',
    content: [
      {
        title: '1990',
        position: 3,
        description:
          "In het begin van de jaren '90 waren de rentes van 10% of 11% eerder regel dan uitzondering. Na 1990 daalden de hypotheekrentes weer, zo ongeveer tot aan het jaar 2000."
      }
    ]
  },
  {
    year: '1989',
    content: [
      {
        title: '1989',
        position: 2,
        description:
          'Er was eind jaren ’80 veel economische en politieke onzekerheid, onder andere als gevolg van de val van de Berlijnse Muur en de economische heropbouw van de voormalige Oostbloklanden.'
      }
    ]
  },
  {
    year: '1985',
    content: [
      {
        title: '1985',
        position: 1,
        description:
          "De hypotheekrente lag in de tweede helft van de jaren '80 echt stukken hoger dan nu. Dat had alles te maken met de hoge kapitaalmarktrente op dat moment."
      }
    ]
  }
];
